<div class="extra-results-attributes">
  <clr-tree>
    <clr-tree-node
      [(clrExpanded)]="markUpExpanded"
      *ngFor="let attribute of markUpSpecifications | resultsHeader: true"
    >
      {{ attribute.longName }}
      <clr-tree-node
        *ngFor="let attribute of activeExtraAttributes | resultsHeader: false"
      >
        <div class="child-long-name">
          {{ attribute.longName }}
        </div>
      </clr-tree-node>
    </clr-tree-node>
  </clr-tree>
</div>
